// @ts-nocheck
import {
    Grid,
    TextField,
    Typography,
    Button
} from "@material-ui/core";
import axios from "axios";
import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import { Select, MenuItem, FormControl, InputLabel, FormHelperText } from "@mui/material";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { SERVER_IP, PrimaryColor } from "../../variables";
import { useLocation, useNavigate } from "react-router-dom";
import { Sidebar } from "../Sidebar";
import CircularProgress from '@mui/material/CircularProgress';
import { getCurrentUserID, getDateTime, inputFieldVariant } from "../../utils";
import { useForm, Controller } from 'react-hook-form';
import { DatePicker, LocalizationProvider } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";

export const UpdateSDPCReport = () => {

    const navigate = useNavigate();
    const { state } = useLocation();
    const [loading, setLoading] = useState(false)
    const [sites, setSites] = useState<any>([]);
    const [selectedMonth, setSelectedMonth] = useState<Date | null>(new Date(state?.Report_Month));

    const { handleSubmit, control, watch } = useForm();

    const updateReport = async (data) => {
        let temp = {
            ...state,
            ...data,
            Deduction_Total: parseInt(DAValue) + parseInt(DBValue) + parseInt(DCValue),
            Report_Month : selectedMonth,
            UpdatedUserID: getCurrentUserID(),
            UpdateDateTime: getDateTime(),
        }
        delete temp['S_No']
        delete temp['SiteName']
        console.log(temp)
        setLoading(true)
        axios
            .put(
                `${SERVER_IP}reportSDPC/update?ReportSDPCID=${temp.ReportSDPCID}`,
                temp
            )
            .then(() => navigate("/ViewStatusReports",{
                state : "SDPC Report Successfully Updated"
            }))
            .catch((err) => {
                toast.error(err?.response?.data?.message || "Couldn't Update Report" );
            }).finally(() => setLoading(false))
    };

    const getSites = () => {
        axios
            .get(`${SERVER_IP}sitedetails`)
            .then((res) => {
                setSites(res.data);
            }).catch((err) => {
                console.log(err)
            });
    };

    useEffect(() => {
        !!!state && navigate('/ViewStatusReports')
        getSites();
    }, []);

    const DAValue = watch("Deduction_A", state?.Deduction_A);
    const DBValue = watch("Deduction_B", state?.Deduction_B);
    const DCValue = watch("Deduction_C", state?.Deduction_C);

    return (

        <>
            <div style={{ marginTop: 80, display: 'flex' }}>
                <Sidebar />
                <Grid container spacing={1} style={{ padding: '10px 30px 10px 30px' }}>
                    <Grid container spacing={3} style={{ margin: '10px auto', borderRadius: '10px', border: `2px solid ${PrimaryColor}` }}>
                        <form style={{ width: '100%' }} onSubmit={handleSubmit(updateReport)}>
                            <Grid container>
                                <Grid item xs={12}>
                                    <Typography style={{ backgroundColor: PrimaryColor, color: 'white' }} variant="h6" gutterBottom>
                                        <AccountCircleIcon style={{ margin: 'auto 5px' }} />
                                        {"Update SDPC Report"}
                                    </Typography>
                                </Grid>

                                <Grid container spacing={3} style={{ margin: 'auto' }}>

                                    <Grid item xs={12} sm={4}>

                                        <Controller
                                            name="SiteID"
                                            control={control}
                                            defaultValue={state?.SiteID}
                                            render={({ field: { onChange, value }, fieldState: { error } }) => (
                                                <FormControl variant={inputFieldVariant} fullWidth error={!!error}>
                                                    <InputLabel>Site </InputLabel>
                                                    <Select
                                                        value={value}
                                                        label="Site"
                                                        onChange={onChange}
                                                    >

                                                        {sites.map((e) => (
                                                            <MenuItem key={e.SiteID} value={e.SiteID}>{e.SiteName}</MenuItem>
                                                        ))}

                                                    </Select>
                                                    {error && <FormHelperText>{error.message}</FormHelperText>}
                                                </FormControl>
                                            )}
                                            rules={{ required: 'This field is required' }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                            <DatePicker
                                                label="Month"
                                                views={['month', 'year']}
                                                // disableFuture
                                                // disabled
                                                value={selectedMonth}
                                                onChange={(newValue) => {
                                                    setSelectedMonth(newValue)
                                                }}
                                                renderInput={(params) => <TextField
                                                    variant="outlined"
                                                    name="selectedMonth"
                                                    fullWidth
                                                    {...params} />
                                                }
                                            />
                                        </LocalizationProvider>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <Controller
                                            name="Deduction_Total"
                                            control={control}
                                            defaultValue={DAValue + DBValue + DCValue}
                                            render={({ field: { onChange, value }, fieldState: { error } }) => (
                                                <TextField
                                                    label="Total"
                                                    type={'number'}
                                                    variant={inputFieldVariant}
                                                    value={
                                                        parseInt(DAValue) + 
                                                        parseInt(DBValue) + 
                                                        parseInt(DCValue)
                                                    }
                                                    fullWidth
                                                    disabled
                                                    onChange={onChange}
                                                    error={!!error}
                                                    helperText={error ? error.message : null}
                                                />
                                            )}
                                            rules={{ required: 'This field is required' }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Controller
                                            name="UnitRate_Mosquito"
                                            control={control}
                                            defaultValue={state?.UnitRate_Mosquito}
                                            render={({ field: { onChange, value }, fieldState: { error } }) => (
                                                <TextField
                                                    label="UnitRate Mosquito"
                                                    variant={'outlined'}
                                                    value={value}
                                                    fullWidth
                                                    type={'number'}
                                                    onChange={onChange}
                                                    error={!!error}
                                                    helperText={error ? error.message : null}
                                                />
                                            )}
                                            rules={{ required: 'This field is required' }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Controller
                                            name="Deduction_A"
                                            defaultValue={state?.Deduction_A}
                                            control={control}
                                            render={({ field: { onChange, value }, fieldState: { error } }) => (
                                                <TextField
                                                    label="Deduction (A)"
                                                    variant={'outlined'}
                                                    value={value}
                                                    fullWidth
                                                    onChange={onChange}
                                                    error={!!error}
                                                    type={'number'}
                                                    helperText={error ? error.message : null}
                                                />
                                            )}
                                            rules={{ required: 'This field is required' }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Controller
                                            name="UnitRate_Termite"
                                            control={control}
                                            defaultValue={state?.UnitRate_Termite}
                                            render={({ field: { onChange, value }, fieldState: { error } }) => (
                                                <TextField
                                                    label="UnitRate Termite"
                                                    type={'number'}
                                                    variant={'outlined'}
                                                    value={value}
                                                    fullWidth
                                                    onChange={onChange}
                                                    error={!!error}
                                                    helperText={error ? error.message : null}
                                                />
                                            )}
                                            rules={{ required: 'This field is required' }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Controller
                                            name="Deduction_B"
                                            defaultValue={state?.Deduction_B}
                                            control={control}
                                            render={({ field: { onChange, value }, fieldState: { error } }) => (
                                                <TextField
                                                    label="Deduction (B)"
                                                    variant={'outlined'}
                                                    value={value}
                                                    fullWidth
                                                    onChange={onChange}
                                                    error={!!error}
                                                    type={'number'}
                                                    helperText={error ? error.message : null}
                                                />
                                            )}
                                            rules={{ required: 'This field is required' }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Controller
                                            name="UnitRate_Pest"
                                            control={control}
                                            defaultValue={state?.UnitRate_Pest}
                                            render={({ field: { onChange, value }, fieldState: { error } }) => (
                                                <TextField
                                                    label="UnitRate Pest"
                                                    type={'number'}
                                                    variant={'outlined'}
                                                    value={value}
                                                    fullWidth
                                                    onChange={onChange}
                                                    error={!!error}
                                                    helperText={error ? error.message : null}
                                                />
                                            )}
                                            rules={{ required: 'This field is required' }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Controller
                                            name="Deduction_C"
                                            defaultValue={state?.Deduction_C}
                                            control={control}
                                            render={({ field: { onChange, value }, fieldState: { error } }) => (
                                                <TextField
                                                    label="Deduction (C)"
                                                    variant={'outlined'}
                                                    value={value}
                                                    fullWidth
                                                    onChange={onChange}
                                                    error={!!error}
                                                    type={'number'}
                                                    helperText={error ? error.message : null}
                                                />
                                            )}
                                            rules={{ required: 'This field is required' }}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid container style={{ marginBottom: '10px' }}>
                                <Grid
                                    item
                                    xs={12}
                                    sm={6}
                                    style={{ textAlign: "center" }}
                                >
                                    <Button
                                        disabled={loading}
                                        color="primary"
                                        size="small"
                                        variant="contained"
                                        type="submit"
                                    >
                                        {loading && <CircularProgress size={20} style={{ marginRight: '10px' }} />}
                                        {"Update Report"}
                                    </Button>
                                </Grid>
                                <Grid
                                    item
                                    xs={12}
                                    sm={6}
                                    style={{ textAlign: "center" }}
                                >
                                    <Button
                                        color="secondary"
                                        size="small"
                                        variant="contained"
                                        onClick={(e) => navigate("/ViewStatusReports")}>
                                        Cancel
                                    </Button>
                                </Grid>

                            </Grid>
                        </form>

                        <ToastContainer />
                    </Grid>
                </Grid>


            </div>
        </>

    );
};
